////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const articleManager = {
	[ActionsTypes.GET_ARTICLE_AVAILABLE_LISTS]: (state) =>
		update(state, {
			articleManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_ARTICLE_AVAILABLE_LISTS_SUCCESS]: (state, payload) => {
		return update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				availableOptions: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_ARTICLE_AVAILABLE_LISTS_FAILURE]: (state, payload) =>
		update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.CREATE_ARTICLE]: (state) =>
		update(state, {
			articleManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_ARTICLE_SUCCESS]: (state, _payload) => {
		return update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.CREATE_ARTICLE_FAILURE]: (state, payload) => {
		return update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_ARTICLE_ITEM]: (state) =>
		update(state, {
			articleManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_ARTICLE_ITEM_SUCCESS]: (state, payload) => {
		return update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				item: {
					$set: payload.data,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_ARTICLE_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.UPDATE_ARTICLE]: (state) =>
		update(state, {
			articleManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_ARTICLE_SUCCESS]: (state, _payload) => {
		return update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_ARTICLE_FAILURE]: (state, payload) => {
		return update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.DELETE_ARTICLE]: (state) =>
		update(state, {
			articleManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.DELETE_ARTICLE_SUCCESS]: (state, _payload) => {
		return update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.DELETE_ARTICLE_FAILURE]: (state, payload) => {
		return update(state, {
			articleManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.RESET_DATA_ARTICLE]: (state) => {
		return update(state, {
			articleManager: {
				item: {
					$set: false,
				},
			},
		})
	},
}

export default articleManager
